import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Typography,
  Switch,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function SalesTax(props) {
  const { include } = props;
  const [open, setOpen] = useState(false);

  return (
    <Box>
      <Button onClick={() => setOpen(true)} size="small">
        {include ? "" : `+ `}SALES TAX
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth={true} maxWidth="xs">
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Sales Tax</Typography>

          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box py={2} textAlign={"center"}>
            <FormControlLabel
              control={
                <Switch
                  checked={props.include}
                  onChange={(e) => {
                    props.onChange(e.target.checked);
                    setOpen(false);
                  }}
                  color={props.include ? "success" : "primary"}
                  sx={{ marginRight: "0" }}
                />
              }
              label="Collect Sales Tax"
            />
            <Box my={2}>
              <Typography variant="body1" color="textSecondary">
                Turn off for wholesale or tax-exempt orders. When on, sales tax applies only to items
                marked taxable in the catalog.
              </Typography>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
